<template>
  <div class='program-training-component'>
    <div class='program-container'>
      <div class="header-line"></div>
      <div class='program-title-container'>
        <img class='title-logo' :src='training.logo'/>
        <div class='title-name'>{{ training.name.toUpperCase() }}</div>
      </div>
      <div class='program-banner-container' v-if="!training.disabled" @click="openModal">
        <div class='program-banner'></div>
        <div class='program-banner-text'>PARTICIPER</div>
      </div>
      <div class='title-border'></div>
      <div class='detail-title'>PROGRAMME</div>
      <div class='program-details-container'>
        <div class='program-detail' v-for='program in training.program' :key='program.id'>
          <div class='program-subtitle'>{{ program.title }}</div>
          <div class='program-list'>
            <div class='program-items' v-for='item in program.items' :key='item.id'>{{ item.content }}</div>
          </div>
        </div>
      </div>
      <button class='program-button' @click='openProgram(training.name)'>DESCRIPTIF</button>
    </div>

    <ParticipateModal v-if='showModalComponent' :trainingId="training.id" @close="closeModal"/>
  </div>
</template>

<script>
import ParticipateModal from '@/components/modals/participateModal'

export default {
  name: 'ProgramTrainingComponent',

  components: {
    ParticipateModal
  },

  props: ['training', 'showTrainings', 'trainingId'],

  data () {
    return {
      showModalComponent: false
    }
  },

  methods: {

    openProgram (trainingName) {
      this.$router.push({ name: 'TrainingPage', params: { trainingName: trainingName, mode: 'description' } })
    },

    openModal () {
      this.showModalComponent = true
      document.body.style.overflow = 'hidden'
    },

    closeModal () {
      this.showModalComponent = false
      document.body.style.overflow = ''
    }

  }
}
</script>

<style lang='scss' scoped>
.header-line {
  $size: 250px;
  position: absolute;
  height: 3px;
  width: $size;
  background: white;
  top: 0;
  left: calc(50% - (#{$size} / 2));

  @include media(phone) {
    width: 164px;
    left: calc(50% - (164px / 2));
  }
}
.program-training-component {
  max-width: 864px;
  width: 100%;

  height: 1200px;
  position: relative;

  @include media(phone) {
    width: unset;
    height: unset;
  }

  .program-container {
    position: relative;
    display: grid;
    grid-template-columns: 12% 1fr 12%;
    height: 100%;
    width: 100%;

    @include media (phone) {
      display: block;
      height: auto;
    }

    .program-title-container {
      display: block;
      grid-column: 2;
      text-align: center;
      padding-top: 25px;
      margin: 0px auto;
      max-height: 100px;
      min-height: 100px;
      min-width: 350px;
      max-width: 350px;

      @include media (phone) {
        max-height: unset;
        min-height: unset;
        min-width: 200px;
        max-width: 200px;
      }

      .title-logo {
        filter: brightness(0) invert(1);
        max-width: 60px;
        max-height: 60px;
        min-height: 60px;
        min-width: 60px;

        @include media (phone) {
          width: 44px;
          height: 44px;
          min-height: unset;
          min-width: unset;
        }
      }

      .title-name {
        color: #FFFFFF;
        font-size: 2.5rem;
        font-weight: 900;
        letter-spacing: -0.03px;
        padding-top: 15px;
        max-width: 350px;
        max-height: 60px;
        min-height: 60px;
        min-width: 350px;

        @include media (phone) {
          font-size: 2.3rem;
          max-width: 200px;
          max-height: 60px;
          min-height: 60px;
          min-width: 200px;
        }
      }
    }

    .program-banner-container {
      display: flex;
      position: absolute;

      max-height: 40px;
      height: 100%;
      width: 112px;

      top: 80px;
      right: -11px;

      align-self: flex-end;
      background-color: white;

      border-bottom-left-radius:100px;
      border-top-left-radius: 100px;

      box-shadow: 0 2px 6px 0 rgba(142,142,142,0.5);
      justify-content: center;

      margin-bottom: 20px;

      transition: all 0.3s ease;
      cursor: pointer;
      user-select: none;

      &:hover {
        background-color: darken($color: white, $amount: 5)
      }

      @include media (phone) {
        top: 54px;
        width: 81px;
        height: 30px;
        right: -9px;
      }

      .program-banner {
        background-color: #D3D3D3;
        -webkit-clip-path: polygon(0 0, 0 100%, 100% 100%);
        clip-path: polygon(0 0, 0 100%, 100% 100%);
        height: 21%;
        position: absolute;
        top: -8px;
        right: -1px;
        width: 7%;

        @include media (phone) {
          top: -6px;
          right: 0px;
        }
      }

      .program-banner-text {
        align-self: center;
        color: #B98A30;
        font-size: 0.8rem;
        font-weight: 900;

        @include media (phone) {
          font-size: 0.6rem;
        }
      }
    }

    .title-border {
      border-bottom: 2px solid #FFFFFF;
      grid-column: 2;
      justify-self: center;
      width: 35%;
      align-self: flex-start;

      @include media (phone) {
        margin: 0px auto;
        margin-bottom: 20px;
      }
    }

    .detail-title {

      align-self: flex-start;
      color: #FFFFFF;
      grid-column: 2;
      text-align: center;

      font-size: 1.1rem;
      font-weight: 900;
      letter-spacing: -0.08px;
      line-height: 32px;

      @include media (phone) {
        margin-bottom: 20px;
      }
    }

    .program-details-container {
      color: #494949;
      grid-column: 2;

      margin: 0 auto;

      @include media (phone) {
        margin: 36px 24px;
      }

      &:last-child {
        padding-bottom: -4px;
      }

      .program-detail {
        border-left: 1px solid #FFFFFF;
        padding-bottom: 14px;
        position: relative;

        &:last-child {
          padding-bottom: 0px;
        }

        .program-subtitle {
          color: #000000;
          font-size: 0.8rem;
          font-weight: bold;
          opacity: 0.84;
          padding-left: 32px;
          padding-bottom: 18px;
          padding-top: 28px;
        }

        .program-list {
          color: #FFFFFF;
          font-size: 0.9rem;
          list-style: none;
          padding-left: -20px;
        }
        .program-items{
          position: relative;
          padding-left: 32px;
          margin-bottom: 4px;
          font-weight: 300;
        }

         .program-items::before {
            color: #FFFFFF;
            content: "";
            WIDTH: 10px;
            position: absolute;
            left: -5px;
            top: 4px;
            height: 10px;
            background: white;
            border-radius: 24px;
        }

          &:last-child{
            &:after{
              content: '';
              height: 3px;
              width: 3px;
              position: absolute;
              background: #B98A30;
              left: -2px;
              bottom: 0;
            }
          }

          &:first-child {
            .program-subtitle {
              padding-top: 4px;
            }
          }
      }
    }

    .program-button {
      @extend %default-button;

      align-self: center;
      justify-self: center;
      grid-column: 2;

      background-color: transparent;
      border: 3px solid #FFFFFF;
      color: #FFFFFF;

      margin: 48px auto;

      &:hover {
        background-color: white;
        color: #B98A30;
      }
    }
  }
}
</style>
